import { useQuery } from 'react-query'

import axiosInstance from 'api/axiosInstance'

export function useSettingsCheck() {
    return useQuery('ageverification-setting', async () => {
        const { data } = await axiosInstance.get('/api/vmc/id-settings')
        return data.enabled // 1 for vmc, 0 for manual
    })
}